












































































































import {Component} from 'vue-property-decorator';
import GenericDistribution from '@/pages/Pages/Distributions/GenericDistribution.vue'
import ViberTemplate from '@/pages/Pages/Templates/ViberTemplate.vue'
import { MsgTransports } from '@/store/types';

@Component({components: {GenericDistribution, ViberTemplate}})
export default class ViberDistribution extends GenericDistribution {

  transport = MsgTransports.VIBER

  beforeRouteLeave(to:any, from:any, next:any) {
    this.beforeLeave(to,from,next)
  }
}
